import { Button } from "antd";
import { Icon, IconLike } from "components/Icon/Icon";
import PuffLoader from "react-spinners/PuffLoader";
import "./IconButton.scss";

type IconButtonProps = {
    icon: IconLike;
    onClick?: (e: any) => void;
    className?: String;
    loading?: Boolean;
    disabled?: boolean;
    onMouseEnter?: (e) => void;
    onMouseLeave?: (e) => void;
};

const IconButton = ({
    icon,
    onClick = () => {},
    className = "",
    loading = false,
    ...props
}: IconButtonProps) => (
    <div
        className={`${className} iconButtonContainer ${
            props?.disabled ? "iconButtonContainerDisabled" : ""
        }`}
    >
        <Button className="iconButton" onClick={onClick} {...props}>
            <Icon icon={icon} />
        </Button>
        {loading && (
            <div className="loadingAnimation">
                <PuffLoader loading size={40} color="#56a8c2" speedMultiplier={2} />
            </div>
        )}
    </div>
);

export default IconButton;
